import React from "react";

import { Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface NoteBoxProps {
  children: React.ReactNode;
}

// A boxed callout for supplementary info, replacing a plain "Note:" text prefix with an icon
const NoteBox: React.FC<NoteBoxProps> = ({ children }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="flex-start"
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "info.main",
        backgroundColor: "#eef6fc",
      }}
    >
      <InfoOutlinedIcon sx={{ color: "info.main", fontSize: "1.2rem", mt: 0.1, flexShrink: 0 }} />
      <Typography variant="body2" sx={{ fontStyle: "italic" }}>
        {children}
      </Typography>
    </Stack>
  );
};

export default NoteBox;
